export default {
  bind: function (el, binding, vNode) {
    event.stopPropagation()
    el.__vueClickOutside__ = event => {
      if (!el.contains(event.target)) {
        // call method provided in v-click-outside value
        vNode.context[binding.expression](event)
      }
    }
    document.addEventListener('click', el.__vueClickOutside__, true)
  },
  unbind: function (el, binding, vNode) {
    // Remove Event Listeners
    document.removeEventListener('click', el.__vueClickOutside__, true)
    el.__vueClickOutside__ = null
  }
}


// WEBPACK FOOTER //
// ./src/lib/clickOutside.js